// * Bootstrap libraries
import './_bootstrap';

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.portalSidebarToggle = {
    attach(context) {

      once(
        'portalSidebarToggle',
        context.querySelectorAll('#sidebarToggle')
      ).forEach((toggle) => {

        const sidebar = document.getElementById('portalSidebar');
        if (!sidebar) {
          return;
        }

        toggle.addEventListener('click', () => {
          sidebar.classList.toggle('sidebar-mini');
        });

      });

    }
  };

})(Drupal, once);
